/**
 * 高德地图（AMap）配置
 * ---------------------------------------------------------------
 * Key 来源：生产服务器 fy (/opt/website/build/index.html, 2024-08 构建产物)
 * 该 key 注册平台为「Web端(JS API)」，可直接用于浏览器端地图。
 *
 * ⚠️ 安全提示：key 属于半公开凭据，硬编码会随源码进版本库。
 *    如需彻底避免，建议改用环境变量（见下方说明）。
 *
 * 关于「安全密钥 securityJsCode」：
 *   高德自 2020-12 起对新申请的 Key 强制要求安全密钥。
 *   本 Key 为更早期申请，历史上未使用（v1.4 时代不需要）。
 *   如果升级到 JS API v2 后地图加载失败并提示鉴权相关错误，
 *   需到 https://lbs.amap.com/console/key 对应应用下获取并填入下方。
 *
 * 未配置 key 或脚本加载失败时，联系页自动回退到内置 echarts 地图。
 */

// 方式一：直接写在这里（当前方式）
export const AMAP_KEY = 'b0b1672f4cc4e621919eaff44ab15ce9'
export const AMAP_SECURITY_CODE = ''

// 方式二：改用环境变量（推荐，可避免 key 进入 git）
// 在 .env.local 中写：REACT_APP_AMAP_KEY=b0b1672f4cc4e621919eaff44ab15ce9
// 然后把上面两行替换为：
// export const AMAP_KEY = process.env.REACT_APP_AMAP_KEY || ''
// export const AMAP_SECURITY_CODE = process.env.REACT_APP_AMAP_SECURITY_CODE || ''

/** 是否已配置好，可以启用高德地图 */
export const isAmapConfigured = Boolean(AMAP_KEY)

/** 涿州厂区坐标 */
export const HQ_LOCATION = { lng: 116.03669, lat: 39.383585 }